import { render } from "./UpgradeModal.vue?vue&type=template&id=4e083457&scoped=true&ts=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=ts"
export * from "./UpgradeModal.vue?vue&type=script&lang=ts"

import "./UpgradeModal.vue?vue&type=style&index=0&id=4e083457&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e083457"]])

export default __exports__